import React from "react";
import "./footer.css";
import useMenu from "../../hooks/useMenuContext";
import { Link } from "react-router-dom";

import iconeAgenda from "../../assets/footer/icone_agenda.png";
import iconeChat from "../../assets/footer/icone_chat.png";
import iconeHome from "../../assets/footer/icone_home.png";

const Footer = () => {
  const { closeMenu } = useMenu();

  return (
    <div id="container-footer">
      <div id="container-footer-icones">
        <Link to="/private/" className="small-box-footer" onClick={closeMenu}>
          <img src={iconeHome} className="icone-footer" alt="home" />
        </Link>
        <Link
          to="/private/agenda"
          className="small-box-footer"
          onClick={closeMenu}
        >
          <img src={iconeAgenda} className="icone-footer" alt="agenda" />
        </Link>
        <Link
          to="/private/chat"
          className="small-box-footer"
          onClick={closeMenu}
        >
          <img src={iconeChat} className="icone-footer" alt="chat" />
        </Link>
      </div>
    </div>
  );
};

export default Footer;
